exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.history-parent[data-v-62b04617] {\n    display: flex;\n    flex-direction: row;\n    height: calc(100vh - 200px);\n    width: 100%;\n    overflow: hidden;\n}\n.history-table[data-v-62b04617] {\n    max-width: 60%;\n    overflow-y: auto;\n}\n.history-map[data-v-62b04617] {\n    flex: 1;\n    position: relative;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62b04617","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view/View_Timesheet_History.vue
// module id = 633
// module chunks = 0